
import axios from '../common/js/axios'
import { host } from '../common/js/config'


// 发送短信需要获取的key
export function getMobileKey(data) {
	const url = `${host}/app/getMobileKey`
	return axios({
		url: url,
		params: data
	})
}

//发送短信接口
export function sendMobileMessage(data) {
	const url = `${host}/app/sendMobileMessage`
	return axios({
		url: url,
		params: data
	})
}

//账号密码登录接口
export function login(data) {
	const url = `${host}/app/login`
	return axios({
		url: url,
		params: data
	})
}

//短信登录或注册
export function registerorlogin(data) {
	const url = `${host}/app/registerorlogin`
	return axios({
		url: url,
		params: data
	})
}

//注销账号
export function cancellation(data) {
	const url = `${host}/app/user/cancellation`
	return axios({
		url: url,
		params: data
	})
}

//密码注册
export function setRegister(data) {
	const url = `${host}/app/register`
	return axios({
		url: url,
		params: data
	})
}


// WEBPACK FOOTER //
// ./src/api/login.js